var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserWhiteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3998 14.4667L11.3332 11.5333C11.1998 11.4 11.0665 11.3333 10.8665 11.3333H5.13317C4.93317 11.3333 4.79984 11.4 4.6665 11.5333L1.59984 14.4667L0.666504 13.5333L3.73317 10.6C4.0665 10.2 4.59984 10 5.13317 10H10.8665C11.3998 10 11.8665 10.2 12.2665 10.6L15.3332 13.5333L14.3998 14.4667Z",
    fill: "#F3FBF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0002 8.66665C5.93353 8.66665 4.2002 6.99998 4.2002 4.86665C4.2002 2.73332 5.93353 1.06665 8.0002 1.06665C10.0669 1.06665 11.8002 2.79998 11.8002 4.86665C11.8002 6.93332 10.0669 8.66665 8.0002 8.66665ZM8.0002 2.39998C6.66686 2.39998 5.53353 3.53332 5.53353 4.86665C5.53353 6.19998 6.66686 7.33332 8.0002 7.33332C9.33353 7.33332 10.4669 6.19998 10.4669 4.86665C10.4669 3.53332 9.33353 2.39998 8.0002 2.39998Z",
    fill: "#F3FBF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhiteIcon);
export default __webpack_public_path__ + "static/media/user-white-icon.93f862ae0907968536213ca18a6878ba.svg";
export { ForwardRef as ReactComponent };